import React from 'react';
import { Search } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useAccessLevel } from 'core/app/AppContext';

export interface IProps {
  value: string;
  searchQueryUpdate: (value: string) => void;
  visible: boolean;
}

export const SearchBar: React.FC<IProps> = ({ searchQueryUpdate, value, visible }) => {
  const [inputValue, setInputValue] = React.useState(value);
  const searchRef = React.useRef(null);
  const { t } = useTranslation();
  const { accessLevel } = useAccessLevel();

  const inputValueRef = React.useRef(inputValue);
  inputValueRef.current = inputValue;

  const handleSearchQueryUpdate = React.useCallback(() => {
    searchQueryUpdate(inputValueRef.current);
  }, [searchQueryUpdate]);

  React.useEffect(() => {
    const timer = setTimeout(handleSearchQueryUpdate, 300);
    return () => clearTimeout(timer);
  }, [inputValue, handleSearchQueryUpdate]);

  React.useEffect(() => {
    if (visible) {
      setFocus();
    }
  }, [visible]);

  const onChange = (value: string) => {
    setInputValue(value);
    searchRef.current.value = value;
  };

  const onClearButtonClicked = () => {
    onChange('');
    setFocus();
  };

  const setFocus = () => {
    searchRef.current.focus();
  };

  return (
    <Search
      maxWidth={920}
      innerRef={searchRef}
      onClearButtonClicked={onClearButtonClicked}
      onChange={onChange}
      value={inputValue}
      placeholder={t('client.search.placeholder', {
        context: accessLevel === 'MultiSite' ? 'multisite' : null,
      })}
      ariaLabel={t('client.search.placeholder', {
        context: accessLevel === 'MultiSite' ? 'multisite' : null,
      })}
    />
  );
};

export default SearchBar;
